<div>
  <div
    *ngFor="let shipment of shipments.controls; let i = index; trackBy: trackByIndex"
    [formGroup]="getShipmentGroup(shipment)"
    class="mb-8 border-b pb-8"
  >
    <h3 class="text-lg font-bold mb-4 flex items-center justify-between">
      <span>Shipment {{ i + 1 }}:</span>
      <span class="flex items-center gap-2">
        <button mat-icon-button aria-label="Remove Shipment" (click)="removeShipment(i)">
          <mat-icon>delete</mat-icon>
        </button>
      </span>
    </h3>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
      <!-- Left Column -->
      <div class="flex flex-col gap-4">
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Shipping Method</mat-label>
          <input matInput formControlName="shippingMethod" placeholder="Shipping Method" />
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Tracking Number</mat-label>
          <input matInput formControlName="trackingNumber" placeholder="Tracking Number" />
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Units Available To Ship</mat-label>
          <input
            matInput
            formControlName="unitsAvailableToShip"
            placeholder="Units Available To Ship"
          />
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Units To Ship</mat-label>
          <input matInput formControlName="units" placeholder="Units To Ship" />
        </mat-form-field>
        <mat-form-field *ngIf="!isOrdersManager()" appearance="fill" class="w-full">
          <mat-label>Total Price</mat-label>
          <input matInput formControlName="totalPrice" placeholder="Total Price" type="number" />
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Weight</mat-label>
          <input matInput formControlName="weight" placeholder="Weight" />
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Date Shipped</mat-label>
          <input
            matInput
            [matDatepicker]="dateShippedPicker"
            formControlName="dateShipped"
            placeholder="MM/DD/YYYY"
          />
          <mat-datepicker-toggle matSuffix [for]="dateShippedPicker"></mat-datepicker-toggle>
          <mat-datepicker #dateShippedPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Quickbooks Invoice</mat-label>
          <input matInput formControlName="quickbooksInvoice" placeholder="Quickbooks Invoice" />
        </mat-form-field>

        <ciwc-order-single-attachment
          [parentForm]="parentForm"
          [orderDetails]="orderDetails"
          [shipmentIndex]="i"
          [viewDisable]="viewDisable"
          fieldName="shipmentPhoto"
          fieldLabel="Shipment Photo"
        >
        </ciwc-order-single-attachment>

        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Shipping Notes</mat-label>
          <input matInput formControlName="shippingNotes" placeholder="Shipping Notes" />
        </mat-form-field>
        <div>
          <ciwc-order-shipment-attachments
            [parentForm]="parentForm"
            [orderDetails]="orderDetails"
            [shipmentIndex]="i"
            [viewDisable]="viewDisable"
          >
          </ciwc-order-shipment-attachments>
        </div>
      </div>
      <!-- Right Column -->
      <div class="flex flex-col gap-4">
        <mat-checkbox formControlName="dropShipment">Drop Shipment ?</mat-checkbox>
        <ng-container *ngIf="shipment.get('dropShipment')?.value">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Drop Ship Address</mat-label>
            <input matInput formControlName="dropShipAddress" placeholder="Drop Ship Address" />
          </mat-form-field>
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Street Address 2</mat-label>
            <input matInput formControlName="dropStreetAddress2" placeholder="Street Address 2" />
          </mat-form-field>
          <div class="grid grid-cols-2 gap-4">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>City</mat-label>
              <input matInput formControlName="dropCity" placeholder="City" />
            </mat-form-field>
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>Zip</mat-label>
              <input matInput formControlName="dropZip" placeholder="Zip" />
            </mat-form-field>
          </div>
          <div class="grid grid-cols-2 gap-4">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>Country</mat-label>
              <mat-select formControlName="dropCountry">
                <mat-option value="">Select Country</mat-option>
                <mat-option
                  *ngFor="let country of countries; trackBy: trackByCountryName"
                  [value]="country.name"
                >
                  {{ country.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>State</mat-label>
              <input matInput formControlName="dropState" placeholder="State" />
            </mat-form-field>
          </div>
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>ATTN / Dept</mat-label>
            <input matInput formControlName="dropAttn" placeholder="ATTN / Dept" />
          </mat-form-field>
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Drop Ship Box</mat-label>
            <input matInput formControlName="dropShipBox" placeholder="Drop Ship Box" />
          </mat-form-field>

          <ciwc-order-single-attachment
            [parentForm]="parentForm"
            [orderDetails]="orderDetails"
            [shipmentIndex]="i"
            [viewDisable]="viewDisable"
            fieldName="dropShipAttachment"
            fieldLabel="Drop Shipment Attachment"
          >
          </ciwc-order-single-attachment>

          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Packing Slip</mat-label>
            <mat-select formControlName="packingSlip">
              <mat-option value="">Select Packing Slip</mat-option>
              <mat-option *ngFor="let slip of packingSlipCategories$ | async" [value]="slip.key">
                {{ slip.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </div>
    </div>
    <div class="flex justify-end">
      <button
        mat-flat-button
        color="primary"
        class="mt-4"
        (click)="sentEmail()"
        *ngIf="!viewDisable"
      >
        SEND SHIPMENT EMAIL
      </button>
    </div>
  </div>
  <button mat-flat-button color="primary" class="mt-4" (click)="addShipment()" *ngIf="!viewDisable">
    Add Shipment
  </button>
</div>
